import { render, staticRenderFns } from "./ddbb.vue?vue&type=template&id=944a912c&scoped=true&"
import script from "./ddbb.vue?vue&type=script&lang=js&"
export * from "./ddbb.vue?vue&type=script&lang=js&"
import style0 from "./ddbb.vue?vue&type=style&index=0&id=944a912c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "944a912c",
  null
  
)

export default component.exports